import React, { useState } from 'react';
import { Button, Drawer } from '@bedrock/components';
import { ShareSquare } from '@bedrock/icons-react';
import HeatingBoostView from "@mpc/common/src/features/HeatingBoost/HeatingBoostView";
import { demandQueryBoostEffectData, outsourceDemandQueryBoostEffectData } from 'services/api';
import { $sType } from '#utils';
import contentMarketingLogo from '@mpc/common/src/images/contentMarketingLogo.svg'
import { ButtonProps } from '@bedrock/components/es/Button';

type Props = {
    detail?: any,
    className?: string,
    style?: React.CSSProperties,
    buttonProps?: ButtonProps,
}

const Index = (props: Props) => {
    const { detail, className, style } = props
    const [value, setValue] = useState([])
    const [visible, setVisible] = useState(false)
    const getApi = (params) => {
        if ($sType === 'inner') {
            return demandQueryBoostEffectData({ ...params })
        } else {
            return outsourceDemandQueryBoostEffectData({ ...params })
        }
    }
    const handleViewBoost = () => {
        setVisible(true)
        getApi({ demand_id: detail?.id }).then((result: any) => {
            if (result?.code === 1) {
                const boostTableList = result?.data?.map((item: any) => {
                    return {
                        ...item,
                        boost_cost: {
                            value: item?.boost_cost,
                            currency: detail?.quote_currency
                        }
                    }
                })
                setValue(boostTableList)
            }
        })
    }
    return (
        <div className={className}>
            <Button
                style={{ textAlign: 'left', marginTop: '5px', ...style }}
                type='checked'
                suffix={<ShareSquare />}
                onClick={handleViewBoost}
                icon={<img src={contentMarketingLogo} className='m-r-4' />}
                {...(props?.buttonProps || {})}
            >
                查看加热助推效果
            </Button>

            <Drawer
                visible={visible}
                footer={null}
                onClose={() => { setVisible(false) }}
                title='查看加热助推效果'
                open={visible}
                maskClosable={false}
                height={'100vh'}
                placement="bottom"
                bodyStyle={{ paddingTop: 0 }}
            >
                <HeatingBoostView value={value} view={true} />
            </Drawer>
        </div>
    )
}

export default Index;